/* ═══════════════════════════════════════════════════════════
   Jaina Paris — Fiche produit sensorielle (thème Prestige)
   Galerie unifiée (flèches / vignettes / dots), sélecteur de
   format (met à jour l'input id natif + prix), CTA sticky mobile.
   L'ajout au panier est délégué au custom element natif
   <product-form> de Prestige (AJAX + ouverture du tiroir).
   ═══════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  function initGallery(root) {
    var track = root.querySelector('[data-jpdp-gallery-track]');
    if (!track) return;

    var slides = track.querySelectorAll('.jpdp__gallery-slide');
    var dots = root.querySelectorAll('.jpdp__gallery-dot');
    var thumbs = root.querySelectorAll('.jpdp__gallery-thumb');
    var prevBtn = root.querySelector('[data-jpdp-gallery-prev]');
    var nextBtn = root.querySelector('[data-jpdp-gallery-next]');
    var count = slides.length;
    if (!count) return;

    function goTo(idx) {
      if (idx < 0 || idx >= count) return;
      var w = slides[0].offsetWidth || track.clientWidth;
      track.scrollTo({ left: w * idx, behavior: 'smooth' });
    }

    function update() {
      var w = slides[0].offsetWidth || 1;
      var idx = Math.round(track.scrollLeft / w);
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === idx); });
      if (prevBtn) prevBtn.toggleAttribute('disabled', idx === 0);
      if (nextBtn) nextBtn.toggleAttribute('disabled', idx === count - 1);
    }

    track.addEventListener('scroll', update, { passive: true });
    update();

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var idx = parseInt(thumb.getAttribute('data-thumb'), 10);
        if (!isNaN(idx)) goTo(idx);
      });
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        var w = slides[0].offsetWidth || 1;
        goTo(Math.round(track.scrollLeft / w) - 1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        var w = slides[0].offsetWidth || 1;
        goTo(Math.round(track.scrollLeft / w) + 1);
      });
    }
  }

  function initVariants(root) {
    var idInput = root.querySelector('[data-jpdp-id]');
    var priceEls = root.querySelectorAll('[data-jpdp-price]');
    var formatEl = root.querySelector('[data-jpdp-format]');
    var btns = root.querySelectorAll('.jpdp__size-btn');
    if (!btns.length) return;

    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.hasAttribute('disabled')) return;

        btns.forEach(function (b) {
          b.classList.remove('is-selected');
          b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('is-selected');
        btn.setAttribute('aria-pressed', 'true');

        var id = btn.getAttribute('data-variant-id');
        var price = btn.getAttribute('data-variant-price');
        var title = btn.getAttribute('data-variant-title');

        if (id && idInput) idInput.value = id;
        if (price) priceEls.forEach(function (el) { el.textContent = price; });
        if (title && formatEl) formatEl.textContent = '· ' + title;
      });
    });
  }

  function initQty(root) {
    var picker = root.querySelector('[data-jpdp-qty]');
    if (!picker) return;
    var input = picker.querySelector('[data-jpdp-qty-input]');
    var minus = picker.querySelector('[data-jpdp-qty-minus]');
    var plus = picker.querySelector('[data-jpdp-qty-plus]');
    if (!input) return;

    if (minus) minus.addEventListener('click', function () {
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
    });
    if (plus) plus.addEventListener('click', function () {
      var max = parseInt(input.max, 10) || 99;
      input.value = Math.min(max, (parseInt(input.value, 10) || 1) + 1);
    });
  }

  function initStickyCta(root) {
    var sticky = document.querySelector('[data-jpdp-sticky-cta]');
    var anchor = root.querySelector('[data-jpdp-add]');
    if (!sticky || !anchor) return;

    var stickyBtn = sticky.querySelector('[data-jpdp-sticky-add]');
    var form = root.querySelector('[data-jpdp-form]');

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        sticky.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, { threshold: 0 });
    observer.observe(anchor);

    if (stickyBtn && form) {
      stickyBtn.addEventListener('click', function () {
        // Délègue au form natif (product-form gère l'AJAX + le tiroir)
        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit();
        } else {
          form.submit();
        }
      });
    }
  }

  function init() {
    var root = document.querySelector('[data-jpdp]');
    if (!root) return;
    initGallery(root);
    initVariants(root);
    initQty(root);
    initStickyCta(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
